import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormItemCommonProps } from '.';
import { cardIdRule } from '../rules';

export const CardIdFormItem = ({ disabled }: FormItemCommonProps) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('Card ID')}
      name="cardId"
      rules={[cardIdRule()]}
    >
      <Input disabled={disabled} />
    </Form.Item>
  );
};
